export default __webpack_public_path__ + "static/media/main-logo.c0ba68c8.svg";